/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FoodDrinkCupHotIcon16Light } from './FoodDrinkCupHotIcon16Light';
import { FoodDrinkCupHotIcon16Regular } from './FoodDrinkCupHotIcon16Regular';
import { FoodDrinkCupHotIcon16Solid } from './FoodDrinkCupHotIcon16Solid';
import { FoodDrinkCupHotIcon20Light } from './FoodDrinkCupHotIcon20Light';
import { FoodDrinkCupHotIcon20Regular } from './FoodDrinkCupHotIcon20Regular';
import { FoodDrinkCupHotIcon20Solid } from './FoodDrinkCupHotIcon20Solid';
import { FoodDrinkCupHotIcon24Regular } from './FoodDrinkCupHotIcon24Regular';
import { FoodDrinkCupHotIcon24Solid } from './FoodDrinkCupHotIcon24Solid';
import { FoodDrinkCupHotIcon32Regular } from './FoodDrinkCupHotIcon32Regular';
import { FoodDrinkCupHotIcon64Regular } from './FoodDrinkCupHotIcon64Regular';
var sizes = {
    16: {
        light: FoodDrinkCupHotIcon16Light,
        regular: FoodDrinkCupHotIcon16Regular,
        solid: FoodDrinkCupHotIcon16Solid,
    },
    20: {
        light: FoodDrinkCupHotIcon20Light,
        regular: FoodDrinkCupHotIcon20Regular,
        solid: FoodDrinkCupHotIcon20Solid,
    },
    24: {
        regular: FoodDrinkCupHotIcon24Regular,
        solid: FoodDrinkCupHotIcon24Solid,
    },
    32: {
        regular: FoodDrinkCupHotIcon32Regular,
    },
    64: {
        regular: FoodDrinkCupHotIcon64Regular,
    },
};
export var FoodDrinkCupHotIcon = forwardRef('FoodDrinkCupHotIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
